import { runEditProgramRequestFlow } from '../shared/runEditProgramRequestFlow';
import { toEditChangeStatusRequest } from './changeStatusModel';
import { programRequestsApi } from '../api/programRequestsApi';

export const editChangeStatusFlow = ({
    form,
    details,
    onError,
    api = programRequestsApi,
}) =>
    runEditProgramRequestFlow({
        request: toEditChangeStatusRequest(form, details),
        onError,
        updateRequest: api.updateChangeStatusRequest,
    });
